import {
	combineReducers,
	compose,
	createStore,
	StoreEnhancer,
	Reducer,
	ReducersMapObject,
	Store,
	StoreEnhancerStoreCreator,
} from "redux";

import { reducers } from "./store";

export default function configureStore(initialState?: any): Store<IApplicationState> {
	// Build middleware. These are functions that can process the actions before they reach the store.
	const windowIfDefined = typeof window === "undefined" ? null : window as any;
	// If devTools is installed, connect to it
	const devToolsExtension = windowIfDefined && windowIfDefined.devToolsExtension as () => StoreEnhancer;
	const createStoreWithMiddleware = compose<StoreEnhancerStoreCreator<{}>>(
		devToolsExtension ? devToolsExtension() : <S>(next: StoreEnhancerStoreCreator<S>) => next,
	)(createStore);

	// Combine all reducers and instantiate the app-wide store instance
	const allReducers = buildRootReducer(reducers);
	const store = createStoreWithMiddleware(allReducers, initialState);

	return store as Store<IApplicationState>;
}

function buildRootReducer(allReducers: ReducersMapObject): Reducer<any> {
	return combineReducers<any>({ ...allReducers });
}



// WEBPACK FOOTER //
// ./src/configure-store.ts